import {
  Box,
  Button,
  Popover,
  StatusIndicator,
} from "@amzn/awsui-components-react";
import { trackButtonClick, Feature } from "../telemetry/telemetry";
import { CopyToClipboard } from "../../util/browserUtils";
import React from "react";

export default (props: { asin: string; componentName: Feature }) => {
  return (
    <div>
      <Box float="left">
        <Popover
          size="small"
          position="top"
          triggerType="custom"
          dismissButton={false}
          content={
            <StatusIndicator type="success">ASIN copied</StatusIndicator>
          }
        >
          <Button
            iconName={"copy"}
            children={"Copy"}
            variant={"icon"}
            onClick={() => {
              trackButtonClick(props.componentName, "copyAsin", {
                asin: props.asin,
              });
              CopyToClipboard(props.asin);
            }}
          />
        </Popover>
      </Box>
    </div>
  );
};
